<template>
    <div class="card mb-3">
        <div class="card-body">
            <Loading v-if="showLoading" />
            <div class="row">
                <div class="col-md-3">
                    <label>از تاریخ <label style="color: red; height: 2px;" >*</label></label>
                    <Datepicker simple auto-submit id="from-date" locale="fa" input-format="YYYY-MM-DD" :max="today" v-model="fromDate" :locale-config="{
                        fa: {
                            displayFormat: 'jYYYY/jMM/jDD',
                            lang: {label: 'شمسی'}
                        }
                    }" />
                </div>
                <div class="col-md-3">
                    <label>تا تاریخ <label style="color: red; height: 2px;" >*</label></label>
                    <Datepicker simple auto-submit id="to-date" locale="fa" input-format="YYYY-MM-DD" :min="fromDate" :max="today" v-model="toDate" :locale-config="{
                        fa: {
                            displayFormat: 'jYYYY/jMM/jDD',
                            lang: {label: 'شمسی'}
                        }
                    }" />
                </div>
                <div class="col-md-3">
                    <label>شماره کارت</label>
                    <input class="form-control ltr-input" v-model="pan" v-mask="'####-####-####-####'">
                </div>
            </div>
            <div class="row" style="display: flex; justify-content: end;">
                <div class="col-md-3" style="margin-top: 29px;">
                    <button class="btn btn-primary btn-block" @click="submit" :disabled="!fromDate || !toDate">
                        <i class="si si-magnifier"></i>
                        جستجو
                    </button>
                </div>
            </div>
            <div class="alert alert-info mt-4 mb-0" v-if="!rows.length && isSearched">
                <p class="mb-0">اطلاعاتی یافت نشد</p>
            </div>
            <hr v-if="rows.length">
            <table class="table table-hover table-bordered mb-0" v-if="rows.length">
                <thead>
                    <tr>
                        <th>شماره کارت</th>
                        <th>نوع رمز</th>
                        <th>تغییر دهنده</th>
                        <th>تاریخ</th>
                        <th>ساعت</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(row,index) in rows" :key="index">
                        <td dir="ltr">{{ row.cardNumber }}</td>
                        <td>{{ row.pinType }}</td>
                        <td>{{ row.userFirstName }} {{ row.userLastName }}</td>
                        <td dir="ltr">{{ row.dateTime.split(' ')[0] }}</td>
                        <td dir="ltr">{{ row.dateTime.split(' ')[1] }}</td>
                    </tr>
                </tbody>
            </table>
            <div class="row mt-3" v-if="pages.length > 1" style="overflow-x: hidden;">
                <div class="col-12" style="overflow-x: auto;">
                    <ul class="pagination pagination-circled">
                        <li class="page-item" v-if="currentPage > 1">
                            <a class="page-link" href="#" v-on:click="currentPage--"><i class="icon ion-ios-arrow-forward"></i></a>
                        </li>
                        <li :class="currentPage == page ? 'page-item active' : 'page-item'" v-for="page in pages" :key="page">
                            <a class="page-link" href="#" v-on:click="currentPage = page">{{ page }}</a>
                        </li>
                        <li class="page-item" v-if="pages.length != currentPage">
                            <a class="page-link" href="#" v-on:click="currentPage++"><i class="icon ion-ios-arrow-back"></i></a>
                        </li>
                    </ul>
                </div>
            </div>
            <p v-if="rows.length" class="mt-4 mb-0">تعداد کل : {{ count }}</p>
        </div>
    </div>
</template>

<script>
import moment from 'moment-jalaali';
export default {
    name: 'CustomerReport',
    data(){
        return {
            showLoading: false,
            isSearched: false,
            rows: [],
            fromDate: '',
            toDate: '',
            currentPage: 1,
            pan: '',
            pages: [1],
            perPage: 10,
            today: moment().format('jYYYY-jMM-jDD'),
            showCard: false,
            count: 0
        }
    },
    watch: {
        currentPage(value){
            this.currentPage = value;
            this.getData();
        }
    },
    methods: {
        getData(){
            this.showLoading = true;
            const postedData = {
                fromDate: moment(this.fromDate,'jYYYY-jMM-jDD').format('YYYY-MM-DDT00:00:00'),
                toDate: moment(this.toDate,'jYYYY-jMM-jDD').format('YYYY-MM-DDT23:59:59'),
                page: this.currentPage - 1,
                take: this.perPage
            };
            if(this.pan)
                postedData.cardNumber = this.pan.replace(/-/g,'');
            this.$api.post('Organizations/Switch/Card/ChangePin/Log',postedData).then(({data}) => {
                if(data.status){
                    this.rows = data.result.data;
                    this.count = data.result.total;
                    let calcPages = Math.ceil(this.count / this.perPage);
                    calcPages = calcPages > 1 ? calcPages : 1
                    let pagesArray = [];
                    for(let i = 1;i <= calcPages;i++)
                        pagesArray.push(i);
                    this.pages = pagesArray;
                }else{
                    this.rows = [];
                }
            }).finally(() => {
                this.isSearched = true;
                this.showLoading = false;
            });
        },
        submit(){
            this.getData();
        }
    }
}
</script>